export default __webpack_public_path__ + "static/CHIRO COIL-48d7a052e7bc56bb84da6204092d9fe5.jpg";